<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
<template #mgmtDialog></template>
